import React from "react";
import { RequireAuth } from "@/lib/auth/RequireAuth";
import { ApplicationSubmitted } from "@/components/ApplicationSubmitted";
import "./ApplicationSubmittedPage.scss";

export const ApplicationSubmittedPage: React.FC = () => {
  return (
    <RequireAuth clientType="consumer">
      <div className="application-submitted-page">
        <div className="application-submitted-page__container">
          <ApplicationSubmitted />
        </div>
      </div>
    </RequireAuth>
  );
};

export default ApplicationSubmittedPage;
